<template>
    <q-page>
        <div class="q-display-2">Użytkownicy administracyjni</div>

        <div>
            <q-btn round icon="add" color="primary" @click="addItem"/>
        </div>

        <q-table
            title="Użytkownicy"
            :data="users"
            :columns="columns"
            row-key="userId"
            :loading="loading"
        >
            <q-td slot="body-cell-options" slot-scope="props" :props="props">
                <q-btn round flat icon="edit" @click="editItem(props.row)"/>
                <q-btn round flat icon="delete" @click="deleteItem(props.row)"/>
            </q-td>
        </q-table>

        <q-modal v-model="editDialogVisible" @hide="closeDialog">
            <q-card v-if="editableItem" class="q-pa-md">
                <q-card-title v-if="adding">
                    Nowy użytkownik
                </q-card-title>
                <q-card-title v-else>
                    Edycja {{editableItem.login}}
                </q-card-title>

                <q-card-main>
                    <q-field label="Login">
                        <q-input v-model="editableItem.login"/>
                    </q-field>

                    <q-field label="Hasło">
                        <q-input type="password" v-model="editableItem.password"/>
                    </q-field>

                    <q-field label="Role">
                        <q-checkbox v-model="editableItem.roles"
                                    v-for="(role, index) in ROLES"
                                    :val="role"
                                    :key="index"
                                    :label="ROLE_TO_NAME_MAP[role]"/>
                    </q-field>

                </q-card-main>

                <q-card-actions align="end">
                    <q-btn
                        @click="closeDialog"
                        label="Anuluj"
                    />

                    <q-btn
                        color="primary"
                        @click="saveItem"
                        label="Zapisz"
                    />

                </q-card-actions>
            </q-card>
        </q-modal>

    </q-page>
</template>

<script>
    import Item from 'quasar-framework/src/mixins/item'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCheckbox from 'quasar-framework/src/components/checkbox/QCheckbox'

    export default {
        name: 'Users',
        components: {QCheckbox, QCardMain, QCardTitle, QCardActions, QInput, Item},
        data () {
            return {
                ROLE_TO_NAME_MAP: {
                    'Admin': 'Admin',
                    'Redactor': 'Redaktor',
                    'Coordinator': 'Koordynator',
                },
                NAME_TO_ROLE_MAP: {
                    'Admin': 'Admin',
                    'Redactor': 'Redaktor',
                    'Coordinator': 'Koordynator',
                },
                ROLES: ['Admin', 'Redactor', 'Coordinator'],
                editDialogVisible: false,
                editableItem: undefined,
                adding: false,
                updating: false,
                items: [],
                columns: [
                    {
                        field: 'login',
                        name: 'login',
                        label: 'Login',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        field: 'type',
                        name: 'type',
                        label: 'Typ',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        name: 'options',
                    },
                ],
            }
        },
        computed: {
            loading () {
                return this.$store.state.loadingUsers
            },
            users () {
                return this.$store.state.users.map(u => {
                    return {
                        ...u,
                        type: u.roles.map(r => this.ROLE_TO_NAME_MAP[r] || r).join(', ')
                    }
                })
            }
        },
        methods: {
            fetch () {
                this.$store.dispatch('fetchUsers')
            },
            editItem (model) {
                this.updating = true
                this.adding = false

                this.editDialogVisible = true

                this.editableItem = {
                    ...model
                }
            },
            addItem () {
                this.adding = true
                this.updating = false

                this.editDialogVisible = true

                this.editableItem = {
                    userId: this.$uuid(),
                    login: '',
                    roles: []
                }
            },
            deleteItem (model) {
                this.$q.dialog({
                    title: `Czy na pewno usunąć użytkownika ${model.login}?`,
                    cancel: true
                }).then((/*reason*/) => {
                    this.$store.dispatch('deleteUser', model.userId)
                })
            },
            saveItem () {
                if (this.adding) {
                    this.$store.dispatch('addUser', this.editableItem).then(() => {
                        this.closeDialog()
                    }).catch(() => {
                        // do nothing - maybe show some error
                    })

                } else if (this.updating) {
                    this.$store.dispatch('updateUser', this.editableItem).then(() => {
                        this.closeDialog()
                    }).catch(() => {
                        // do nothing - maybe show some error
                    })
                }
            },
            closeDialog () {
                this.editableItem = undefined
                this.editDialogVisible = false

                this.adding = false
                this.updating = false
            },
        },
        mounted () {
            this.fetch()
        },
    }
</script>

<style  lang="scss">
</style>